// @ts-strict-ignore
import { EditorMode } from 'flow/editor/context/constants';
import type { ElementType } from '../../store/engine/types';
import { ruleBuilderEditMode } from 'flow/editor/components/NodeEditorDrawer/ThresholdsTab/RuleBuilderContainer/types';

export function getElementType<E extends { publicId: string }>(element: E): ElementType {
  const { publicId } = element;
  const elementTypeRegex = /([a-z]*)__\w{20}/;
  const matches = publicId.match(elementTypeRegex);

  if (matches.length === 0) {
    return null;
  }

  // the elementType capture group goes on the second item
  return matches[1] as ElementType;
}

export function checkIfEditorModeIsEditable(editorMode: EditorMode) {
  return [EditorMode.CheckedOut, EditorMode.Standard].includes(editorMode);
}

export function getEditMode(
  editorMode: EditorMode,
  isSubEditorActive: boolean,
) {
  // we use the disabled flag to disable the rest of the rule builder when a sub editor is open
  if (isSubEditorActive) return ruleBuilderEditMode.disabled;

  return [EditorMode.CheckedOut, EditorMode.Standard].includes(editorMode)
    ? ruleBuilderEditMode.editable
    : ruleBuilderEditMode.readOnly;
}
